import { Dialog } from '@mui/material';
import React from 'react';
import {
    ModalBody,
    ModalFooter,
    ModalHeader,
} from '@Components/ModalComponents';

interface IDeleteDialogProps {
    isOpen: boolean;
    onClose: () => void;
    isDeleting: boolean;
    onDelete: () => void;
    entityName: string;
    id?: string;
}

const DeleteDialog = (props: IDeleteDialogProps) => {
    const { isOpen, onClose, isDeleting, onDelete, entityName, id } = props;

    return (
        <Dialog id={id} open={isOpen} onClose={onClose}>
            <ModalHeader
                id={`${id}-header`}
                title={`Are you sure you want to delete ${entityName}?`}
                onCancel={onClose}
                isCancelDisabled={isDeleting}
            />
            <ModalBody />
            <ModalFooter
                id={`${id}-footer`}
                onCancel={onClose}
                onSubmit={onDelete}
                isSubmitting={isDeleting}
                submitText="Delete"
            />
        </Dialog>
    );
};

export default DeleteDialog;
